module.exports = __webpack_public_path__ + "static/media/icon-unfreeze.483d2227.svg";